import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
/* import __COLOCATED_TEMPLATE__ from './insert-hyperlink.hbs'; */
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { cancel } from "@ember/runloop";
import { isEmpty } from "@ember/utils";
import { searchForTerm } from "discourse/lib/search";
import { prefixProtocol } from "discourse/lib/url";
import discourseDebounce from "discourse-common/lib/debounce";
import TEMPLATE from "./insert-hyperlink.hbs";
import { setComponentTemplate } from "@ember/component";
let InsertHyperlink = (_class = class InsertHyperlink extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "linkText", _descriptor, this);
    _initializerDefineProperty(this, "linkUrl", _descriptor2, this);
    _initializerDefineProperty(this, "selectedRow", _descriptor3, this);
    _initializerDefineProperty(this, "searchResults", _descriptor4, this);
    _initializerDefineProperty(this, "searchLoading", _descriptor5, this);
    _defineProperty(this, "_debounced", void 0);
    _defineProperty(this, "_activeSearch", void 0);
  }
  willDestroy() {
    super.willDestroy(...arguments);
    cancel(this._debounced);
  }
  highlightRow(e, direction) {
    const index = direction === "down" ? this.selectedRow + 1 : this.selectedRow - 1;
    if (index > -1 && index < this.searchResults.length) {
      document.querySelectorAll(".internal-link-results .search-link")[index].focus();
      this.selectedRow = index;
    } else {
      this.selectedRow = -1;
      document.querySelector("input.link-url").focus();
    }
    e.preventDefault();
  }
  selectLink(el) {
    this.searchResults = [];
    this.linkUrl = el.href;
    this.selectedRow = -1;
    if (!this.linkText && el.dataset.title) {
      this.linkText = el.dataset.title;
    }
    document.querySelector("input.link-text").focus();
  }
  async triggerSearch() {
    if (this.linkUrl.length < 4 || this.linkUrl.startsWith("http")) {
      this.abortSearch();
      return;
    }
    this.searchLoading = true;
    this._activeSearch = searchForTerm(this.linkUrl, {
      typeFilter: "topic"
    });
    try {
      const results = await this._activeSearch;
      this.searchResults = results?.topics || [];
    } finally {
      this.searchLoading = false;
      this._activeSearch = null;
    }
  }
  abortSearch() {
    this._activeSearch?.abort();
    this.searchResults = [];
    this.searchLoading = false;
  }
  keyDown(event) {
    switch (event.key) {
      case "ArrowDown":
        this.highlightRow(event, "down");
        break;
      case "ArrowUp":
        this.highlightRow(event, "up");
        break;
      case "Enter":
        // override Enter behavior when a row is selected
        if (this.selectedRow > -1) {
          const selected = document.querySelectorAll(".internal-link-results .search-link")[this.selectedRow];
          this.selectLink(selected);
          event.preventDefault();
          event.stopPropagation();
        }
        break;
      case "Escape":
        // Esc should cancel dropdown first
        if (this.searchResults.length) {
          this.searchResults = [];
          event.preventDefault();
          event.stopPropagation();
        } else {
          this.args.closeModal();
          document.querySelector(".d-editor-input")?.focus();
        }
        break;
    }
  }
  mouseDown(event) {
    if (!event.target.closest(".inputs")) {
      this.searchResults = [];
    }
  }
  ok() {
    const origLink = this.linkUrl;
    const linkUrl = prefixProtocol(origLink);
    const sel = this.args.model.toolbarEvent.selected;
    if (isEmpty(linkUrl)) {
      return;
    }
    const linkText = this.linkText || "";
    if (linkText.length) {
      this.args.model.toolbarEvent.addText(`[${linkText}](${linkUrl})`);
    } else if (sel.value) {
      this.args.model.toolbarEvent.addText(`[${sel.value}](${linkUrl})`);
    } else {
      this.args.model.toolbarEvent.addText(`[${origLink}](${linkUrl})`);
      this.args.model.toolbarEvent.selectText(sel.start + 1, origLink.length);
    }
    this.args.closeModal();
  }
  linkClick(e) {
    if (!e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      e.stopPropagation();
      this.selectLink(e.target.closest(".search-link"));
    }
  }
  updateLinkText(event) {
    this.linkText = event.target.value;
  }
  search(event) {
    this.linkUrl = event.target.value;
    this._debounced = discourseDebounce(this, this.triggerSearch, 400);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "linkText", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.model.linkText;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "linkUrl", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectedRow", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return -1;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "searchResults", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "searchLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "keyDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "keyDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mouseDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "mouseDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ok", [action], Object.getOwnPropertyDescriptor(_class.prototype, "ok"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "linkClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "linkClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateLinkText", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateLinkText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "search", [action], Object.getOwnPropertyDescriptor(_class.prototype, "search"), _class.prototype)), _class);
export { InsertHyperlink as default };
setComponentTemplate(TEMPLATE, InsertHyperlink);